<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green" title="למען ידעו">
                    <v-data-table
                        :headers="headers"
                        :items="lemanYidey"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <td
                                style="min-width: 200px"
                                class="text-xs-left font-weight-regular"
                            >
                                {{ item.Date }}
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ item.Name }}
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ item.FromPhone }}
                            </td>
                            <td>
                                <audio
                                    controls
                                    :src="item.RecordingURL"
                                ></audio>
                            </td>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1
            },

            headers: [
                { value: "Timestamp", text: "Timestamp" },
                { value: "Name", text: "Sender" },
                { value: "FromPhone", text: "Sender Phone" },
                { value: "RecordingURL", text: "Recording" }
            ],

            lemanYidey: []
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage
                  )
                : 0;
        }
    },
    created() {
        this.firebaseSetup();
    },
    methods: {
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56"
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("leman_yeidey");

            const leman_yeideyRef = ref.orderByKey().limitToLast(100);

            leman_yeideyRef.on(
                "value",
                snapshot => {
                    const lemanYidey = Object.values(snapshot.val()).map(
                        message => {
                            message.FromPhone = this.formatPhoneNumber(
                                message.FromPhone
                            );

                            message.Date = moment(message.Timestamp).format(
                                "LLL"
                            );

                            return message;
                        }
                    );
                    this.lemanYidey = lemanYidey.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.pagination.totalItems = this.lemanYidey.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                }
            );

            ref.on("child_added", (data, prevChildKey) => {});
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        }
    }
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
</style>
